var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgYoutube = function SvgYoutube(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.79 5.43c.861.231 1.533.906 1.766 1.767.61 2.458.57 7.105.013 9.602a2.5 2.5 0 0 1-1.767 1.766c-2.432.602-13.326.528-15.618 0a2.5 2.5 0 0 1-1.766-1.767c-.575-2.342-.535-7.296-.013-9.588a2.5 2.5 0 0 1 1.767-1.766c3.251-.679 14.46-.46 15.618-.013m-9.73 3.572 5.224 2.996-5.224 2.995z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };